import EnvConfig from '../../envConfig';

export default {
  publicEcwidApiV3StorageUrl: (storeId, key) =>
    `${EnvConfig.ECWID_API_URL}/${storeId}/storage/${key}`,
  privateEcwidApiV3StorageUrl: (storeId, key) =>
    `${EnvConfig.PRIVATE_ECWID_API_URL}/${storeId}/storage/${key}`,
  publicEcwidApiV3ProfileUrl: (storeId) =>
    `${EnvConfig.ECWID_API_URL}/${storeId}/profile`,
  countryApiUrl: () =>
    `${EnvConfig.API_SERVER_HOST}/api/v1/storefront/countries`,
};
